import { render, staticRenderFns } from "./edit1.vue?vue&type=template&id=23fac2eb&"
import script from "./edit1.vue?vue&type=script&lang=js&"
export * from "./edit1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports